module.exports = __webpack_public_path__ + "static/img/pcshow@2x.f4aa0169.png";